/**
 * Links to stored files.
 *
 * Meeting summaries and client documents are private (15 Sep 2026) — a plain
 * storage URL no longer opens them. The app keeps each file's original URL as
 * its name and opens it through the backend, which checks you are signed in and
 * redirects to a link that works for five minutes. A plain <a href> cannot send
 * the Authorization header, so the session rides in the query string, the same
 * way the API already accepts it for downloads.
 */
import { getAuthToken, getDashboardApiUrl } from '../services/api';

const OUR_PRIVATE_FILE = /\/storage\/v1\/object\/(?:public|sign)\/Fileuploads\//;

export const toViewableUrl = (url) => {
  if (!url || typeof url !== 'string') return url;
  if (OUR_PRIVATE_FILE.test(url)) {
    const plain = url.replace('/object/sign/', '/object/public/').split('?')[0];
    const params = new URLSearchParams({ url: plain, view: '1', access_token: getAuthToken() || '' });
    return `${getDashboardApiUrl()}/dashboard/files/open?${params.toString()}`;
  }
  // Anything else (an external link someone pasted) opens as it always did.
  const extension = url.split('?')[0].split('.').pop()?.toLowerCase();
  if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'].includes(extension)) {
    return `https://docs.google.com/viewer?url=${encodeURIComponent(url)}&embedded=true`;
  }
  return url;
};
